import { createFileRoute } from '@tanstack/react-router';

import { SharedDiagramGate } from '@/pages/shared-viewer/shared-diagram-gate';

export const Route = createFileRoute('/s/$token')({
    component: SharedTokenRoute,
    // Both shared viewers (crochet, grid) mount a page-level header tray
    // that owns the app-nav corner on desktop; the account corner belongs
    // to the crochet properties column / the grid tray's trailing slot.
    staticData: { ownTopLeft: true, ownTopRight: true },
});

function SharedTokenRoute() {
    const { token } = Route.useParams();
    return <SharedDiagramGate source={{ kind: 'token', token }} />;
}
